<template>
  <transition name="fb">
    <div class="floating-banner" v-if="showFloatingBanner">
      <slot></slot>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'FloatingBannerBase',
  props: {
    showFloatingBanner: {
      type: Boolean,
      default: false
    },
  }
}</script>

<style scoped lang="scss">
.floating-banner {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  z-index: 1000;
}

.fb-enter-active,
.fb-leave-active {
  transition: all 200ms ease-out 0s;
}

.fb-enter, .fb-leave-to {
  opacity: 0;
  transform: translate(0, 20px);
}

.fb-enter-to, .fb-leave {
  opacity: 1;
  transform: translate(0, 0);
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/FloatingBannerBase.vue